import { render, staticRenderFns } from "./StepCombinacoesLimites.vue?vue&type=template&id=9bcfddd6&scoped=true"
import script from "./StepCombinacoesLimites.vue?vue&type=script&lang=js"
export * from "./StepCombinacoesLimites.vue?vue&type=script&lang=js"
import style0 from "./StepCombinacoesLimites.vue?vue&type=style&index=0&id=9bcfddd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bcfddd6",
  null
  
)

export default component.exports